function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1996(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24.31,
    height: 12.12,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7314285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.155,
    y: 6.06
  }, "\n        Tyrrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 12.12,
    width: 24.31,
    height: 16.36,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.09
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.155,
    y: 20.299999999999997
  }, "\n        Hyde\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 28.48,
    width: 24.31,
    height: 20.56,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4266666666666663
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.155,
    y: 38.76
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 49.04,
    width: 24.31,
    height: 26.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.051666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.155,
    y: 62.215
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 75.38,
    width: 24.31,
    height: 28.38,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.862
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.155,
    y: 89.57
  }, "\n        Gates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 103.76,
    width: 24.31,
    height: 29.28,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.0775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.155,
    y: 118.4
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 133.04,
    width: 24.31,
    height: 29.76,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.862
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.155,
    y: 147.92
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 162.8,
    width: 24.31,
    height: 29.82,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.862
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.155,
    y: 177.71
  }, "\n        Swain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 192.62,
    width: 24.31,
    height: 32.16,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.431
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.155,
    y: 208.7
  }, "\n        Perquimans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 224.78,
    width: 24.31,
    height: 33.93,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.701111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.155,
    y: 241.745
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 258.71,
    width: 24.31,
    height: 34.26,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.051666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.155,
    y: 275.84
  }, "\n        Chowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 292.97,
    width: 24.31,
    height: 36.31,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.431
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.155,
    y: 311.125
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 329.27,
    width: 24.31,
    height: 38.37,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.472857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.155,
    y: 348.455
  }, "\n        Pamlico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 367.64,
    width: 24.31,
    height: 41.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.051666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.155,
    y: 388.46
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 409.29,
    width: 24.31,
    height: 45.22,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.701111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.155,
    y: 431.90000000000003
  }, "\n        Currituck\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 454.51,
    width: 24.31,
    height: 47.5,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.0775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.155,
    y: 478.26
  }, "\n        Hoke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 502.01,
    width: 24.31,
    height: 47.63,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.03875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.155,
    y: 525.825
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 549.64,
    width: 24.31,
    height: 49.34,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.862
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.155,
    y: 574.31
  }, "\n        Avery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 598.98,
    width: 24.31,
    height: 50.24,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.051666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.155,
    y: 624.1
  }, "\n        Bertie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 649.22,
    width: 24.31,
    height: 50.78,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.051666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.155,
    y: 674.61
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.31,
    y: 0,
    width: 31.85,
    height: 41.31,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.9625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.235,
    y: 20.655
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.17,
    y: 0,
    width: 33.15,
    height: 41.31,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.735714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 72.745,
    y: 20.655
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.31,
    y: 0,
    width: 33.24,
    height: 41.31,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.155
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.93,
    y: 20.655
  }, "\n        Hertford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 122.55,
    y: 0,
    width: 35.36,
    height: 41.31,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2145454545454544
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 140.23,
    y: 20.655
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 157.91,
    y: 0,
    width: 35.94,
    height: 41.31,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.188
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 175.88,
    y: 20.655
  }, "\n        Anson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193.85,
    y: 0,
    width: 36.88,
    height: 41.31,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.688
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 212.29,
    y: 20.655
  }, "\n        Pasquotank\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.73,
    y: 0,
    width: 36.96,
    height: 41.31,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.696
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 249.20999999999998,
    y: 20.655
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.69,
    y: 0,
    width: 37.17,
    height: 41.31,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.64625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 286.275,
    y: 20.655
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 304.86,
    y: 0,
    width: 38.46,
    height: 41.31,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.494285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 324.09000000000003,
    y: 20.655
  }, "\n        Caswell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 343.32,
    y: 0,
    width: 39.13,
    height: 41.31,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.89125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 362.885,
    y: 20.655
  }, "\n        Scotland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 382.45,
    y: 0,
    width: 40.32,
    height: 41.31,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.72
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 402.61,
    y: 20.655
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 422.77,
    y: 0,
    width: 40.95,
    height: 41.31,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 443.245,
    y: 20.655
  }, "\n        Yancey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 463.72,
    y: 0,
    width: 42.25,
    height: 41.31,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.885000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 484.845,
    y: 20.655
  }, "\n        Bladen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 505.96,
    y: 0,
    width: 46.88,
    height: 41.31,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.3275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 529.4,
    y: 20.655
  }, "\n        Ashe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 552.84,
    y: 0,
    width: 47.29,
    height: 41.31,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.885000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 576.485,
    y: 20.655
  }, "\n        Person\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 600.13,
    y: 0,
    width: 49.54,
    height: 41.31,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.901428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 624.9,
    y: 20.655
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 649.67,
    y: 0,
    width: 50.33,
    height: 41.31,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.262
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 674.8349999999999,
    y: 20.655
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.31,
    y: 41.31,
    width: 47.86,
    height: 44.03,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.0075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.239999999999995,
    y: 63.325
  }, "\n        Dare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.31,
    y: 85.34,
    width: 47.86,
    height: 47.35,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.47
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.239999999999995,
    y: 109.015
  }, "\n        Vance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.31,
    y: 132.69,
    width: 47.86,
    height: 47.73,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.303333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.239999999999995,
    y: 156.555
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.31,
    y: 180.42,
    width: 47.86,
    height: 48.59,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.976666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.239999999999995,
    y: 204.71499999999997
  }, "\n        Pender\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.31,
    y: 229.01,
    width: 47.86,
    height: 49.96,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.9825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.239999999999995,
    y: 253.98999999999998
  }, "\n        McDowell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.31,
    y: 278.98,
    width: 47.86,
    height: 50.11,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.976666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.239999999999995,
    y: 304.035
  }, "\n        Yadkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.31,
    y: 329.09,
    width: 47.86,
    height: 50.43,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.976666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.239999999999995,
    y: 354.30499999999995
  }, "\n        Duplin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.31,
    y: 379.51,
    width: 47.86,
    height: 51.36,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.239999999999995,
    y: 405.19
  }, "\n        Davie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.31,
    y: 430.87,
    width: 47.86,
    height: 52.09,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.317777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.239999999999995,
    y: 456.915
  }, "\n        Granville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.31,
    y: 482.96,
    width: 47.86,
    height: 52.09,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.9825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.239999999999995,
    y: 509.005
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.31,
    y: 535.05,
    width: 47.86,
    height: 52.4,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9883333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.239999999999995,
    y: 561.25
  }, "\n        Transylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.31,
    y: 587.46,
    width: 47.86,
    height: 53.01,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.9825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.239999999999995,
    y: 613.965
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.31,
    y: 640.46,
    width: 47.86,
    height: 59.54,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.953333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.239999999999995,
    y: 670.23
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.18,
    y: 41.31,
    width: 50.13,
    height: 59.12,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.26625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 97.245,
    y: 70.87
  }, "\n        Beaufort\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 122.3,
    y: 41.31,
    width: 50.47,
    height: 59.12,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.411666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 147.535,
    y: 70.87
  }, "\n        Stokes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.78,
    y: 41.31,
    width: 53.05,
    height: 59.12,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.578571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 199.305,
    y: 70.87
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225.83,
    y: 41.31,
    width: 53.64,
    height: 59.12,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.705
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 252.65,
    y: 70.87
  }, "\n        Columbus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 279.46,
    y: 41.31,
    width: 56.74,
    height: 59.12,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.105714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 307.83,
    y: 70.87
  }, "\n        Watauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 336.2,
    y: 41.31,
    width: 56.77,
    height: 59.12,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.110000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 364.585,
    y: 70.87
  }, "\n        Sampson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 392.98,
    y: 41.31,
    width: 56.92,
    height: 59.12,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.3244444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 421.44,
    y: 70.87
  }, "\n        Edgecombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 449.9,
    y: 41.31,
    width: 60.61,
    height: 59.12,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.445714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 480.205,
    y: 70.87
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 510.51,
    y: 41.31,
    width: 61.18,
    height: 59.12,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.912
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 541.1,
    y: 70.87
  }, "\n        Rutherford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 571.69,
    y: 41.31,
    width: 62.35,
    height: 59.12,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.853333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 602.865,
    y: 70.87
  }, "\n        Lenoir\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 634.04,
    y: 41.31,
    width: 65.96,
    height: 59.12,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.824
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 667.02,
    y: 70.87
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.18,
    y: 100.43,
    width: 62.21,
    height: 62.83,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.887142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.28500000000001,
    y: 131.845
  }, "\n        Haywood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.18,
    y: 163.26,
    width: 62.21,
    height: 63.66,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.368333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.28500000000001,
    y: 195.08999999999997
  }, "\n        Stanly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.18,
    y: 226.92,
    width: 62.21,
    height: 65.28,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.887142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.28500000000001,
    y: 259.56
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.18,
    y: 292.2,
    width: 62.21,
    height: 65.36,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.77625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.28500000000001,
    y: 324.88
  }, "\n        Carteret\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.18,
    y: 357.57,
    width: 62.21,
    height: 66.46,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.368333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.28500000000001,
    y: 390.8
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.18,
    y: 424.03,
    width: 62.21,
    height: 67.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.368333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.28500000000001,
    y: 457.60999999999996
  }, "\n        Wilson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.18,
    y: 491.19,
    width: 62.21,
    height: 68.06,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.887142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.28500000000001,
    y: 525.22
  }, "\n        Harnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.18,
    y: 559.25,
    width: 62.21,
    height: 68.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.912222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.28500000000001,
    y: 593.725
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.18,
    y: 628.2,
    width: 62.21,
    height: 71.8,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.77625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.28500000000001,
    y: 664.1
  }, "\n        Caldwell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.39,
    y: 100.43,
    width: 62.67,
    height: 74.74,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 165.725,
    y: 137.8
  }, "\n        Onslow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.05,
    y: 100.43,
    width: 65.64,
    height: 74.74,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.94
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 229.87,
    y: 137.8
  }, "\n        Craven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 262.7,
    y: 100.43,
    width: 69,
    height: 74.74,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.8
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 297.2,
    y: 137.8
  }, "\n        Moore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 331.7,
    y: 100.43,
    width: 71.87,
    height: 74.74,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.267142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 367.635,
    y: 137.8
  }, "\n        Robeson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 403.57,
    y: 100.43,
    width: 73.59,
    height: 74.74,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.176666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 440.365,
    y: 137.8
  }, "\n        Cleveland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 477.17,
    y: 100.43,
    width: 73.65,
    height: 74.74,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.4125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 513.995,
    y: 137.8
  }, "\n        Nash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 550.81,
    y: 100.43,
    width: 73.72,
    height: 74.74,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.744
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 587.67,
    y: 137.8
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 624.54,
    y: 100.43,
    width: 75.46,
    height: 74.74,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.473999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 662.27,
    y: 137.8
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.39,
    y: 175.17,
    width: 75,
    height: 76.32,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.89,
    y: 213.32999999999998
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.39,
    y: 251.5,
    width: 75,
    height: 83.41,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.89,
    y: 293.205
  }, "\n        Johnston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.39,
    y: 334.91,
    width: 75,
    height: 84.86,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.333333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.89,
    y: 377.34000000000003
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.39,
    y: 419.76,
    width: 75,
    height: 85.62,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.89,
    y: 462.57
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.39,
    y: 505.38,
    width: 75,
    height: 97.15,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.714285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.89,
    y: 553.955
  }, "\n        Iredell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.39,
    y: 602.53,
    width: 75,
    height: 97.47,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.89,
    y: 651.265
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.39,
    y: 175.17,
    width: 92.02,
    height: 80.46,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 255.39999999999998,
    y: 215.39999999999998
  }, "\n        Pitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 301.41,
    y: 175.17,
    width: 95.07,
    height: 80.46,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.092
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 348.94500000000005,
    y: 215.39999999999998
  }, "\n        Rowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 396.48,
    y: 175.17,
    width: 100,
    height: 80.46,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.0575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 446.48,
    y: 215.39999999999998
  }, "\n        Cabarrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 496.49,
    y: 175.17,
    width: 101.34,
    height: 80.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.0575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 547.16,
    y: 215.39999999999998
  }, "\n        Alamance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 597.82,
    y: 175.17,
    width: 102.18,
    height: 80.46,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.0575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 648.9100000000001,
    y: 215.39999999999998
  }, "\n        Davidson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.39,
    y: 255.63,
    width: 89.69,
    height: 100.66,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.812857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 254.23499999999999,
    y: 305.96
  }, "\n        Catawba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.39,
    y: 356.29,
    width: 89.69,
    height: 101.55,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.948333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 254.23499999999999,
    y: 407.065
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.39,
    y: 457.85,
    width: 89.69,
    height: 118.94,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.153636363636364
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 254.23499999999999,
    y: 517.32
  }, "\n        New_Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.39,
    y: 576.79,
    width: 89.69,
    height: 123.21,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.948333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 254.23499999999999,
    y: 638.395
  }, "\n        Gaston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.08,
    y: 255.63,
    width: 123.13,
    height: 105.16,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.516
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 360.645,
    y: 308.21
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 422.21,
    y: 255.63,
    width: 127.93,
    height: 105.16,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 486.17499999999995,
    y: 308.21
  }, "\n        Buncombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 550.14,
    y: 255.63,
    width: 149.86,
    height: 105.16,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.526666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 625.0699999999999,
    y: 308.21
  }, "\n        Durham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.08,
    y: 360.79,
    width: 149.07,
    height: 146.38,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.91142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 373.615,
    y: 433.98
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.08,
    y: 507.17,
    width: 149.07,
    height: 192.83,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.63375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 373.615,
    y: 603.585
  }, "\n        Guilford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 448.16,
    y: 360.79,
    width: 251.84,
    height: 164.61,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.964545454545457
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 574.08,
    y: 443.095
  }, "\n        Mecklenburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 448.16,
    y: 525.4,
    width: 251.84,
    height: 174.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 43.65
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 574.08,
    y: 612.6999999999999
  }, "\n        Wake\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1996);
export default __webpack_public_path__ + "static/media/1996.f3addcab629b43005ddf59c1f06eea05.svg";
export { ForwardRef as ReactComponent };